import { useSearchParams } from "react-router-dom";
import { EstimateSection, ServiceAreas } from "../components/Sections";
import { PageHero } from "./ServicePage";
import { IMG } from "../data/site";
import { Seo } from "../components/Seo";

export default function Contact() {
  const [params] = useSearchParams();
  return (
    <main data-testid="contact-page">
      <Seo title="Contact a Roofer in Milwaukee, WI | Good Home Improvement LLC" description="Call or text 414-396-7510 for a free roofing, siding or gutter estimate. Office at 9000 W Chester St, Ste 100, Milwaukee, WI 53214. Mon–Fri 9:30–7:30, Sat 12:30–5." path="/contact" />
      <PageHero img={IMG.crewHero} crumb="Contact" kicker="Contact" lines={["Let's talk", <span key="a" className="text-amber-400">about your home.</span>]} sub="Request a free estimate for roofing, siding or gutters. We'll get back to you quickly." testid="contact-hero" />
      <EstimateSection address={params.get("address") || ""} title={["Request your", "free estimate"]} />
      <div className="pt-24"><ServiceAreas /></div>
    </main>
  );
}
